import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
    {
      path: '/EnrollChoose',
      name: 'EnrollChoose',
      component:resolve => require(['@/view/enroll/EnrollChoose'], resolve),
    },
    {
      path: '/login/:id',
      name: 'login',
      component:resolve => require(['@/login'], resolve),
    },
    {
      path: '/PrintView',
      name: 'PrintView',
      component:resolve => require(['@/view/user/PrintView'], resolve),
    },
    {
      path: '/xfCard',
      name: 'xfCard',
      component:resolve => require(['@/view/xuefen/xfCard'], resolve),
    },
    {
      path: '/Certificate',
      name: 'Certificate',
      component:resolve => require(['@/view/xuefen/Certificate'], resolve),
    },
    {
      path: '/EnrollView',
      name: 'EnrollView',
      component:resolve => require(['@/view/enroll/EnrollView'], resolve),
    },
    {
      path: '/EnrollType',
      name: 'EnrollType',
      component:resolve => require(['@/view/enroll/EnrollType'], resolve),
    },
    {
      path: '/EnrollRegister',
      name: 'EnrollRegister',
      component:resolve => require(['@/view/enroll/EnrollRegister'], resolve),
    },
    {
      // path: '/EnrollUpload',
      path: '/EnrollUpload/:id',
      name: 'EnrollUpload',
      component:resolve => require(['@/view/enroll/EnrollUpload'], resolve),
    },
     //报名
    {
      path: '/EnrollCourse',
      name: 'EnrollCourse',
      component:resolve => require(['@/view/enroll/EnrollCourse'], resolve),
    },
    {
      path: '/EnrollInvoice',
      name: 'EnrollInvoice',
      component:resolve => require(['@/view/enroll/EnrollInvoice'], resolve),
    },
    {
      path: '/EnrollMessage',
      name: 'EnrollMessage',
      component:resolve => require(['@/view/enroll/EnrollMessage'], resolve),
    },
    {
      path: '/EnrollPay',
      name: 'EnrollPay',
      component:resolve => require(['@/view/enroll/EnrollPay'], resolve),
    },
    {
      path: '/EnrollFinish',
      name: 'EnrollFinish',
      component:resolve => require(['@/view/enroll/EnrollFinish'], resolve),
    },
     // 其他报名
     {
      path: '/GqpxView/:id',
      name: 'GqpxView',
      component:resolve => require(['@/view/gqpx/EnrollView'], resolve),
    },
     {
      path: '/GqpxCourse',
      name: 'GqpxCourse',
      component:resolve => require(['@/view/gqpx/EnrollCourse'], resolve),
    },
     {
      path: '/GqpxInvoice',
      name: 'GqpxInvoice',
      component:resolve => require(['@/view/gqpx/EnrollInvoice'], resolve),
    },
    {
      path: '/GqpxMessage',
      name: 'GqpxMessage',
      component:resolve => require(['@/view/gqpx/EnrollMessage'], resolve),
    },
    {
      path: '/GqpxPay',
      name: 'GqpxPay',
      component:resolve => require(['@/view/gqpx/EnrollPay'], resolve),
    },
    {
      path: '/GqpxFinish',
      name: 'GqpxFinish',
      component:resolve => require(['@/view/gqpx/EnrollFinish'], resolve),
    },
    //岗前培训用户中心
    {
      path: '/GqpxView',
      name: 'GqpxView',
      component:resolve => require(['@/view/gqpxt/GqpxView'], resolve),
      redirect: {name:'GqpxMessageT'},
      children: [
        {
          path: '/GqpxHome/:id',
          name: 'GqpxHome',
          component:resolve => require(['@/view/gqpxt/GqpxHome'], resolve),
        },
        {
          path: '/GqpxMessageT',
          name: 'GqpxMessageT',
          component:resolve => require(['@/view/gqpxt/GqpxMessageT'], resolve),
        },
        {
          path: '/GqpxList',
          name: 'GqpxList',
          component:resolve => require(['@/view/gqpxt/GqpxList'], resolve),
        },
        {
          path: '/GqpxLists',
          name: 'GqpxLists',
          component:resolve => require(['@/view/gqpxt/GqpxLists'], resolve),
        },
        {
          path: '/GqpxTest',
          name: 'GqpxTest',
          component:resolve => require(['@/view/gqpxt/GqpxTest'], resolve),
        },
        {
          path: '/GqpxInvoiceT',
          name: 'GqpxInvoiceT',
          component:resolve => require(['@/view/gqpxt/GqpxInvoiceT'], resolve),
        },
        { 
          path: '/GqpxCredit',
          name: 'GqpxCredit',
          component:resolve => require(['@/view/gqpxt/GqpxCredit'], resolve),
        },
        { 
          path: '/GqpxQuestion',
          name: 'GqpxQuestion',
          component:resolve => require(['@/view/gqpxt/GqpxQuestion'], resolve),
        },
        {
            path: '/GqpxReset',
            name: 'GqpxReset',
            component:resolve => require(['@/view/gqpxt/GqpxReset'], resolve),
          },
      ]
    },
    //用户中心
  {
    path: '/UserView',
    name: 'UserView',
    component:resolve => require(['@/view/user/UserView'], resolve),
    redirect: {name:'UserMessage'},
    children: [
      {
        path: 'HomeView',
        name: 'HomeView',
        component:resolve => require(['@/view/user/HomeView'], resolve),
      },
      {
        path: 'UserMessage',
        name: 'UserMessage',
        component:resolve => require(['@/view/user/UserMessage'], resolve),
      },
      {
        path: 'CourseList',
        name: 'CourseList',
        component:resolve => require(['@/view/user/CourseList'], resolve),
      },
      {
        path: '/CourseDetail/:id',
        name: 'CourseDetail',
        component:resolve => require(['@/view/user/CourseDetail'], resolve),
      },
      {
        path: 'OnlineTest',
        name: 'OnlineTest',
        component:resolve => require(['@/view/user/OnlineTest'], resolve),
      },
      {
        path: 'InvoiceView',
        name: 'InvoiceView',
        component:resolve => require(['@/view/user/InvoiceView'], resolve),
      },
      { 
        path: 'CreditInquiry',
        name: 'CreditInquiry',
        component:resolve => require(['@/view/user/CreditInquiry'], resolve),
      },
      { 
        path: 'QuestionView',
        name: 'QuestionView',
        component:resolve => require(['@/view/user/QuestionView'], resolve),
      },
      {
          path: 'ResetPwd',
          name: 'ResetPwd',
          component:resolve => require(['@/view/user/ResetPwd'], resolve),
        }
    ]
  },
  {
    path: '/',
    name: 'Content',
    component:resolve => require(['@/view/content/Content'], resolve),
    redirect: {name:'Index'},
    children: [
      {
        path: 'Index',
        name: 'Index',
        component:resolve => require(['@/view/content/Index'], resolve),
        // component: Index,
        meta: {
            requireAuth: true,
            // keepAlive: true // 用户列表需要被缓存
        }
      },
      {
        path: 'ImportantQuestion',
        name: 'ImportantQuestion',
        component:resolve => require(['@/view/content/ImportantQuestion'], resolve),
      },
      {
        path: '/Search/:id',
        name: 'Search',
        component:resolve => require(['@/view/content/Search'], resolve),
      },
       {
        path: '/List/:id',
        name: 'List',
        component:resolve => require(['@/view/content/List'], resolve),
      },
      {
        path: 'WVideo',
        name: 'WVideo',
        component:resolve => require(['@/view/content/WVideo'], resolve),
      },
      {
        path: 'Download',
        name: 'Download',
        component:resolve => require(['@/view/content/Download'], resolve),
      },
      {
        path: '/Article/:num',
        name: 'Article',
        component:resolve => require(['@/view/content/Article'], resolve),
      },
      {
        path: '/Center/:num',
        name: 'Center',
        component:resolve => require(['@/view/content/Center'], resolve),
      },
    //   {
    //     path: 'AboutUs',
    //     name: 'AboutUs',
    //     component:resolve => require(['@/view/content/AboutUs'], resolve),
    //   }
    ]
  }
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js